var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-description"},[(_vm.texts)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.texts)}}):_c('p',[_vm._v("Данные отсутствуют")])])
}
var staticRenderFns = []

export { render, staticRenderFns }